/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskWorkflowItem } from './TaskWorkflowItem';
import {
    TaskWorkflowItemFromJSON,
    TaskWorkflowItemFromJSONTyped,
    TaskWorkflowItemToJSON,
    TaskWorkflowItemToJSONTyped,
} from './TaskWorkflowItem';

/**
 * 
 * @export
 * @interface FindAllTaskWorkflowItems200Response
 */
export interface FindAllTaskWorkflowItems200Response {
    /**
     * 
     */
    data: Array<TaskWorkflowItem>;
}

/**
 * Check if a given object implements the FindAllTaskWorkflowItems200Response interface.
 */
export function instanceOfFindAllTaskWorkflowItems200Response(value: object): value is FindAllTaskWorkflowItems200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function FindAllTaskWorkflowItems200ResponseFromJSON(json: any): FindAllTaskWorkflowItems200Response {
    return FindAllTaskWorkflowItems200ResponseFromJSONTyped(json, false);
}

export function FindAllTaskWorkflowItems200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllTaskWorkflowItems200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TaskWorkflowItemFromJSON)),
    };
}

export function FindAllTaskWorkflowItems200ResponseToJSON(json: any): FindAllTaskWorkflowItems200Response {
    return FindAllTaskWorkflowItems200ResponseToJSONTyped(json, false);
}

export function FindAllTaskWorkflowItems200ResponseToJSONTyped(value?: FindAllTaskWorkflowItems200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(TaskWorkflowItemToJSON)),
    };
}

